<template>
	<div>
		<div class="loginpage" v-if="state == 1">
			<div class="logintop">
				<div class="loginNop">
					<img src="../../assets/icon/login/login-bg-top.png" alt=""
						style="width: 140px;height: 50px;margin-left: 120px;vertical-align: middle;padding-top: 15px">
					<div class="loginTopLeft" style="">
						客服热线：4006-986-985
						<div class="loginTopLeftBtn">
							联系客服
						</div>
					</div>
				</div>
			</div>
			<div class="login">
				<img src="../../assets/icon/login/login-bg.png" alt="">
				<div class="centerTextOne">
					专注医疗技术 服务人类健康
				</div>
				<div class="centerTextTow">
					/ 致力于成为全球领先的医疗器械创新企业
				</div>
				<transition name="form-fade" mode="in-out">
					<div class="login-from" v-show="showLogin">
						<div class="LeftLogin">
							<!-- @click="LoginLeftClick(item.state)" -->
							<div class="CodeLogin" v-for="(item,index) of LoginCodeList" :key="index"
								:class="[ PageState == index+1 ? 'CodeLogins' : 'CodeLogin' ]"
								:style="[{ borderRadius: `${ item.BorderRadius }` }]">
								{{ item.title }}
							</div>
						</div>
						<div class="a ">
						</div>
						<!-- <div class="a" :class="[PageState == 1 ? 'linears' : 'linear' ]">
          </div> -->
						<transition :name="direction">
							<router-view></router-view>
						</transition>
					</div>
				</transition>
			</div>
		</div>
		<div class="loginpage" v-if="state == 2">
			<div class="logintop">
				<img src="../../assets/icon/login/login-bg-top.png" alt=""
					style=" width: 140px;height: 50px;margin-left: 40px;vertical-align: middle;">
				<div
					style="display: inline-block; font-size: 18px;margin-left: 16px;color: rgb(214 214 214);line-height: 80px;">
					/</div>
				<img src="../../assets/icon/login/login-logo.png" alt=""
					style=" width: 160px;height: 80px;margin-left: 18px;vertical-align: middle;">
				<span v-if="base_url.includes('bs.oudot.cn')"
					style="font-size:32px;color:red;transform: translate(24px, 8px);display: inline-block;">测&nbsp;&nbsp;试&nbsp;&nbsp;服</span>
				<div
					style="display: inline-block;float: right;line-height: 80px;margin-right: 60px;font-size: 16px;color: #343434;font-family: 微软雅黑;font-weight: bold;">
					鸿雁-归创通桥渠道数据综合管理系统登录页</div>
			</div>
			<div class="login">
				<!-- <transition name="form-fade" mode="in-out"> -->
				<div class="login-from" v-show="showLogin">
					<img src="../../assets/icon/login/login-input.png" alt=""
						style="width: 120px;height: 120px;position: absolute;margin-left: 400px;top: 0;right: 0;">
					<div class="login-from-top">
						账号密码登录
						<div class="login-from-top-b"></div>
					</div>
					<div class="login-from-top-tow">
						/ 欢迎登录鸿雁-归创通桥渠道数据综合管理系统 /
					</div>
					<div class="error-top" v-if="error != ''">
						<div class="error">
							<img src="../../assets/icon/icon-del2.png" alt=""
								style="width: 20px;height: 20px;vertical-align: middle;margin-left: 20px">
							{{ this.error }}
						</div>
					</div>

					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="ruleForm">
						<el-form-item prop="userName">
							<el-input type="text" v-model="ruleForm.userName"
								placeholder="用户名/邮箱账号"><span></span></el-input>
						</el-form-item>
						<el-form-item prop="password">
							<el-input type="password" v-model="ruleForm.password"
								placeholder="密码"><span></span></el-input>
						</el-form-item>
						<el-form-item>
							<div @click="onSubmit" class="btn-OK-submit">登录</div>
						</el-form-item>
					</el-form>
				</div>
				<!-- </transition> -->
			</div>
		</div>
		<DialogFrom width="480px" title="重置密码" :dialogVisible="dialogVisiblesedit" @cancel="canceledit"
			@dialogOK="dialogOKedit">
			<div class="from-tips" v-if="pwdTips">
				{{pwdTips}}
			</div>
			<el-form class="from" :model="NewRuleForm">
				<el-form-item prop="password">
					<el-input type="password" v-model="NewRuleForm.newPassword"
						placeholder="新密码"><span></span></el-input>
				</el-form-item>
				<el-form-item prop="password">
					<el-input type="password" v-model="NewRuleForm.secPassword"
						placeholder="确认新密码"><span></span></el-input>
				</el-form-item>
			</el-form>
		</DialogFrom>
	</div>

</template>

<script>
	import {
		Login,
		UserInfoMun,
		ChangePassWithoutLogin
	} from '@/api/home'
	import DialogFrom from '@/components/dialog-from.vue'
	import LoginCodeList from "./LoginFromList/LoginCodeList"
	export default {
		components: {
			DialogFrom
		},
		data() {
			return {
				base_url: location.host,
				error: '',
				dialogVisiblesedit: false,
				ruleForm: {
					userName: '',
					password: ''
				},
				NewRuleForm: {
					newPassword: '',
					secPassword: ''
				},
				state: 2,
				rules: {
					username: [{
						required: true,
						message: '请输入用户名',
						trigger: 'blur'
					}, ],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}],
				},
				showLogin: false,
				PageState: 1, //控制首页 登录 顶部切换动效
				onChage: 0,
				LoginCodeList: [],
				rules: {},
				direction: "",
				error: "",
				pwdTips: ''
			}
		},

		created() {
			localStorage.removeItem("comm-token")
			// this.keyupSubmit()
			// let index = this.$route.path.replace("/", "");
		},
		mounted() {
			this.showLogin = true
			this.LoginCodeList = JSON.parse(JSON.stringify(LoginCodeList))
		},
		watch: {
			// 监听login登录页面切换
			$route: {
				immediate: true, // 一旦监听到路由的变化立即执行
				handler(to, from) {
					// 临时只有账号密码登录
					if (to.name == "CodeLoginPage" || to.name == "login") {
						this.$router.push({
							name: "UPLoginPage",
						})
					}
					// 账号密码验证码登录
					// if (to.name == "login") {
					//   this.direction = 'slide-left';
					//   this.PageState = 1
					//   //console.log(to.name == "login");
					//   this.$router.push({
					//     name: "CodeLoginPage",
					//   })
					// } else if (to.name == "CodeLoginPage") {
					//   this.direction = 'slide-left';
					//   this.PageState = 1
					// } else if (to.name == "UPLoginPage") {
					//   this.direction = 'slide-right';
					//   this.PageState = 2
					// }
				},
			},
		},
		methods: {
			LoginLeftClick(state) {
				if (state == 0) {
					this.PageState = 1
					this.$router.push({
						name: "CodeLoginPage",
						query: {
							PageState: this.PageState
						}
					})
				}
				if (state == 1) {
					this.PageState = 2
					this.$router.push({
						name: "UPLoginPage",
						query: {
							PageState: this.PageState
						}
					})

				}
			},
			// 重置密码
			async ChangePassWithoutLogin() {
				// (?=.*[~!@#$%^&*])[\da-zA-Z~!@#$%^&*]
				var reg = /^(?=.*\d)(?=.*[a-zA-Z]).{6,}$/;
				var regFalg = reg.test(this.NewRuleForm.newPassword); //true,说明有英文字母或数字
				if (this.NewRuleForm.newPassword == '') {
					this.$message.warning('密码不能为空！')
					return;
				}
				if (this.NewRuleForm.secPassword == '') {
					this.$message.warning('确认密码不能为空！')
					return;
				}
				if (!regFalg) {
					this.$message.warning('输入至少包含字母和数字以及6位数以上！')
					return;
				}
				if (this.NewRuleForm.newPassword !== this.NewRuleForm.secPassword) {
					this.$message.warning('两次密码不一致！')
					return;
				}
				let {
					code,
					message
				} = await ChangePassWithoutLogin({
					userName: this.ruleForm.userName,
					password: this.$md5(this.ruleForm.password).toUpperCase(),
					newPassword: this.$md5(this.NewRuleForm.newPassword).toUpperCase(),
					secPassword: this.$md5(this.NewRuleForm.secPassword).toUpperCase()
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '重置成功！'
					});
					this.login(this.$md5(this.NewRuleForm.secPassword).toUpperCase());
					this.dialogVisiblesedit = false
					this.pwdTips = '';
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			onSubmit() {
				this.login(this.$md5(this.ruleForm.password).toUpperCase())
			},
			// Login
			async login(password) {
				const loading = this.$loading({
					lock: true,
					text: '登录中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let reslogin = await Login({
					userName: this.ruleForm.userName,
					password: password
				})
				if (reslogin.code == 0) {
					this.error = ""
					console.log(reslogin);
					if (reslogin.data.NeedChangePW) {
						this.$message.warning('请重置密码！')
						setTimeout(() => {
							this.dialogVisiblesedit = true;
							this.pwdTips = reslogin.data.ChangePWReason;
							loading.close();
						}, 1000);
						return;
					}
					this.$message({
						type: 'success',
						message: '登录成功'
					});
					const startTime = new Date().getTime()
					// 保存登录时间
					localStorage.setItem("token-startTime", startTime)
					this.$store.commit("SET_TOKEN", reslogin.data.Token)
					this.$store.commit("SET_USERINFO", reslogin.data.user)
					this.userInfoMun()
					loading.close();
				} else {
					this.error = reslogin.message
					// this.$message({
					//   type: 'error',
					//   message: reslogin.message
					// });
					loading.close();
				}
			},
			// 菜单信息
			async userInfoMun() {
				const loading = this.$loading({
					lock: true,
					text: '加载菜单中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let res = await UserInfoMun({})
				if (res.code == 0) {
					this.$store.commit("MENUS_DATA", res.data)
					localStorage.setItem("MenusData", JSON.stringify(res.data))
					localStorage.setItem("ysfBoo", false)
					// this.$router.replace({
					//   path: '/homeCom/HomePage?NodeID=60'
					// });
					window.location.reload()
					this.$router.push({
						path: '/homePage'
					});
					this.$store.state.rsf = true
					loading.close()
				} else {
					this.$notify.error({
						title: '菜单加载异常',
						message: res.message
					})
				}
			},
			canceledit() {
				this.dialogVisiblesedit = false
				this.pwdTips = '';
			},
			dialogOKedit() {
				this.ChangePassWithoutLogin();
			},

		},
	}
</script>

<style lang='less' scoped>
	@import "../../style/mixin.less";

	.a {
		// 账号验证码宽度
		// width: 190px;
		// 账号登录宽度
		width: 376px;
		height: 2px;
		background: #e71d43;
	}

	.linear {
		transition: all 0.3s linear;
		transform: translateX(100%);
	}

	.linears {
		transition: all 0.3s linear;
		transform: translateX(0%);
	}

	.slide-right-enter-active,
	.slide-right-leave-active,
	.slide-left-enter-active,
	.slide-left-leave-active {
		will-change: transform;
		transition: all 0.5s;
		position: absolute;
		width: 100%;
		left: 0;
	}

	.slide-right-enter {
		transform: translateX(-100%);
	}

	.slide-right-leave-active {
		transform: translateX(100%);
	}

	.slide-left-enter {
		transform: translateX(100%);
	}

	.slide-left-leave-active {
		transform: translateX(-100%);
	}

	.loginTopLeft {
		display: inline-block;
		float: right;
		line-height: 93px;
		margin-right: 120px;
		font-size: 18px;
		color: #343434;
		font-family: 微软雅黑;
		font-weight: bold;
		color: #00266d;

		.loginTopLeftBtn {
			display: inline-block;
			width: 106px;
			height: 40px;
			background: rgb(231 29 67);
			box-shadow: 0px 2px 4px 0px rgb(235 29 68 / 20%);
			border-radius: 2px;
			line-height: 40px;
			font-size: 14px;
			color: rgb(255 255 255);
			font-family: "微软雅黑";
			text-align: center;
			margin-left: 33px;
		}
	}

	.ruleForm {
		margin-top: 13%;
	}

	.loginpage {
		height: 90%;
		width: 100%;
		// overflow: hidden;
	}

	.logintop {
		width: 100%;
		height: 91px;
		background: #fff;
		position: relative;

		.loginNop {
			// border: 1px solid red;
			// width: 1180px;
			// height: 64px;
			// margin: 0 auto;
		}
	}

	.login {
		width: 100%;
		height: 100%;
		// background-size: 100%;
		position: relative;

		img {
			width: 100%;
			height: 100%;
		}

		.centerTextOne {
			display: inline-block;
			color: #ffffff;
			font-size: 36px;
			position: absolute;
			left: 250px;
			top: 342px;
		}

		.centerTextTow {
			color: #ffffff;
			font-size: 20px;
			position: absolute;
			left: 285px;
			top: 402px;
		}
	}

	.login::before {
		content: "";
		background: url("../../assets/channel/login/loginCente.png") no-repeat 0px 0px;
		width: 50px;
		height: 50px;
		background-size: 100%;
		position: absolute;
		// border: 1px solid red;
		bottom: 450px;
		left: 705px;
	}

	.login-from {
		.wh(380px, auto);
		position: absolute;
		top: 400px;
		right: 280px;
		margin-top: -240px;
		margin-left: 298px;
		// padding: 40px;
		border-radius: 8px;
		background-color: #fff;
		overflow: hidden;
		cursor: pointer;

		.LeftLogin {
			display: flex;

			.CodeLogin {
				// 账号验证码登录的宽度
				width: 190px;
				// 只有账号的宽度
				width: 376px;
				height: 60px;
				border: 1px solid #e6e8eb;
				border-radius: 0px 8px 0px 0px;
				font-size: 16px;
				color: #9ca5b8;
				font-size: 16px;
				font-weight: bold;
				line-height: 60px;
				text-align: center;
			}

			.CodeLogins {
				// 账号验证码登录的宽度
				// width: 190px;
				// 只有账号的宽度
				width: 376px;
				height: 60px;
				border: 1px solid #e6e8eb;
				border-radius: 0px 8px 0px 0px;
				font-size: 16px;
				color: #e71d43;
				font-size: 16px;
				font-weight: bold;
				line-height: 60px;
				text-align: center;
			}
		}

		.login-from-top {
			font-size: 18px;
			font-family: "微软雅黑";
			font-weight: 600;
			color: #c20f2f;

			.login-from-top-b {
				width: 108px;
				height: 7px;
				background: #c20f2f;
				opacity: 0.2;
				position: absolute;
				margin-top: -10px;
			}
		}

		.login-from-top-tow {
			font-size: 14px;
			font-family: "微软雅黑";
			font-weight: 400;
			color: #999999;
			line-height: 20px;
			margin-top: 8px;
		}

		.error {
			width: 440px;
			min-height: 44px;
			border: 1px solid #e695a3;
			background: #fff1f0;
			font-size: 14px;
			color: #c20f2f;
			line-height: 44px;
			margin-top: 32px;
		}

		.error-top {
			width: 440px;
			height: 44px;
			margin-top: 32px;
		}

		.from-top-title {
			position: absolute;
			width: 100%;
			top: -50px;
			left: 0;

			p {
				font-size: 30px;
				color: #fff;
			}
		}
	}

	.form-fade-enter-active,
	.form-fade-leave-active {
		transition: all 2s;
	}

	.form-fade-enter,
	.form-fade-leave-active {
		transform: translate3d(0, -50px, 0);
		opacity: 0;
	}

	@keyframes lefts {
		0% {
			width: 0px;
			opacity: 0;
		}

		100% {
			width: 180px;
			opacity: 1;
		}
	}

	/deep/.el-input__inner {
		width: 440px;
		height: 50px;
		border-radius: 2px;
	}

	.loginpage {
		height: 100%;
		overflow: hidden;
	}

	.logintop {
		width: 100%;
		height: 80px;
		background: #fff;
	}

	.login {
		width: 100%;
		height: 849px;
		background: url("../../assets/icon/login/login-bg.png") no-repeat 0px 0px;
		background-size: 100%;
	}

	.login-from {
		width: 440px;
		position: absolute;
		top: 47%;
		left: 50%;
		margin-top: calc(-360px / 2);
		margin-left: calc(-440px / 2);
		padding: 40px;
		border-radius: 1px;
		background-color: rgb(255 255 255);

		.login-from-top {
			font-size: 18px;
			font-family: "微软雅黑";
			font-weight: 600;
			color: #c20f2f;

			.login-from-top-b {
				width: 108px;
				height: 7px;
				background: #c20f2f;
				opacity: 0.2;
				position: absolute;
				margin-top: -10px;
			}
		}

		.login-from-top-tow {
			font-size: 14px;
			font-family: "微软雅黑";
			font-weight: 400;
			color: #999999;
			line-height: 20px;
			margin-top: 8px;
		}

		.from-top-title {
			position: absolute;
			width: 100%;
			top: -50px;
			left: 0;

			p {
				font-size: 30px;
				color: #fff;
			}
		}

		.btn-OK-submit {
			width: 100%;
			height: 40px;
			background-color: #e71d43;
			text-align: center;
			font-size: 14px;
			color: #fff;
			font-family: "微软雅黑";
			border-radius: 2px;
			margin-top: 20px;
			line-height: 40px;
		}
	}

	.form-fade-enter-active,
	.form-fade-leave-active {
		transition: all 2s;
	}

	.form-fade-enter,
	.form-fade-leave-active {
		transform: translate3d(0, -50px, 0);
		opacity: 0;
	}

	.from-tips {
		color: red;
		padding-bottom: 16px;
	}
</style>